import {Brick, registerBrick} from 'olympe';

const DROPDOWN_LABEL = 'dropdownLabel';
export default class GetUserDropdownLabel extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<!Object>} users
     * @param {function()} forwardEvent
     * @param {function(*)} setUsers
     */
    update($, [users], [forwardEvent, setUsers]) {
        // if same email and display name, cannot create a separate entry: remove these
        const noMailDuplicates = users.filter((user, idx, self) => idx === self.findIndex((other) => other['displayName'] === user['displayName'] && other['mail'] === user['mail']));
        const usersSeen = new Map();
        for (const user of noMailDuplicates) {
            const displayName = user['displayName'];
            let label = displayName;
            if (usersSeen.get(displayName)) {
                // we have a duplicate user
                const firstDuplicate = usersSeen.get(displayName);
                if (!firstDuplicate['duplicateModified']) {
                    // modify the first occurence of duplicate only once
                    firstDuplicate['duplicateModified'] = true;
                    firstDuplicate[DROPDOWN_LABEL] = this.newDisplayName(firstDuplicate['displayName'], firstDuplicate['mail']);
                }
                // duplicate users get more specific label
                label = this.newDisplayName(user['displayName'], user['mail']);
                user['duplicateModified'] = true;
            } else {
                // not a duplicate
                usersSeen.set(displayName, user);
            }
            // set label for current user
            user[DROPDOWN_LABEL] = label;
        }
        // users object are modified in place
        setUsers(noMailDuplicates);
        // Trigger the output Control Flow
        forwardEvent();
    }

    newDisplayName(displayName, email) {
        return `${displayName} (${email})`;
    }
}

registerBrick('018a7417b2d403a78ac1', GetUserDropdownLabel);
